import styled from 'styled-components';
import {Button} from '@guestapp/ui';
import {device} from '@guestapp/ui/src/utils/device';

export const Wrapper = styled.div`
  padding: 40px 24px;
  @media (min-width: ${device.tablet}) {
    padding: 16px 40px;
  }
`;

export const Container = styled.div`
  min-height: calc(100vh - 80px);
  background: #f7f9fb;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${device.tablet}) {
    width: 326px;
    margin: 0 auto;
    min-height: 575px;
    background: none;
  }
`;

export const Title = styled.div`
  color: #152946;
  text-align: center;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.36px;
  margin-bottom: 21px;
`;

export const Subtitle = styled.div`
  color: #152946;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 24px;
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Footer = styled.footer`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 18px;
  margin-top: auto;
`;

export const FooterLink = styled(Button)`
  color: #152946;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export const Header = styled.div`
  display: none;

  @media (min-width: ${device.tablet}) {
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    margin-bottom: 70px;
  }
`;

export const HeaderImg = styled.img`
  object-fit: contain;
  background-size: contain;
`;

export const HeaderTitle = styled.div`
  color: #152946;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.36px;
`;

export const LogoAndTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const ContentWrapper = styled.div<{$isLoading?: boolean}>`
  opacity: ${props => (props.$isLoading ? 0 : 1)};
`;
